const AppConfig = {
  api: {
    url: 'https://api.xosoredcross.com/'
  }
}

export default AppConfig;
